<template>
  <div id="app" class="bg-gray-100 min-h-screen">
    <img
      class="logo"
      v-if="authState !== 'signedin' && !user"
      src="@/assets/screenlab-logo-blue.svg"
      alt="ScreenLab"
    />
    <amplify-authenticator
      username-alias="email"
      :initial-auth-state="initialScreen"
    >
      <amplify-sign-up
        slot="sign-up"
        username-alias="email"
        :form-fields.prop="signUpFormFields"
      ></amplify-sign-up>
      <amplify-sign-in slot="sign-in" username-alias="email"></amplify-sign-in>
      <div>
        <Navbar
          :user="user"
          :notifications="notifications"
          :scans-in-progress="scansInProgress"
          v-if="user && user.attributes && notifications"
          v-on:remove-notification="removeNotification"
          @signed-out="
            user = undefined;
            authState = undefined;
            notifications = [];
            scansInProgress = 0;
            window.location.href = '/';
          "
        />
        <router-view v-on:scan="postScan"></router-view>
        <p class="mt-12 text-center px-2 pb-12 text-xs text-gray-500">
          &copy; 2021 <span class="font-bold">ScreenLab</span> Ltd. All rights
          reserved. By using this website you are signifying your agreement to
          our terms and conditions.
        </p>
      </div>
    </amplify-authenticator>
  </div>
</template>

<script>
window.LOG_LEVEL = "INFO";
import { Auth, API, Analytics } from "aws-amplify";
import { AuthState, onAuthUIStateChange } from "@aws-amplify/ui-components";
import Navbar from "@/components/Navbar";

export default {
  name: "app",
  components: {
    Navbar,
  },
  data() {
    return {
      user: undefined,
      authState: undefined,
      notifications: [],
      scansInProgress: 0,
      signUpFormFields: [
        {
          type: "name",
          label: "Name",
          placeholder: "Enter your full name",
          required: true,
        },
        {
          type: "email",
          label: "Email Address",

          required: true,
        },
        {
          type: "password",
          label: "Password",
          required: true,
        },
      ],
    };
  },
  methods: {
    addNotification(notification) {
      this.notifications.push(notification);
      setTimeout(() => {
        this.removeNotification(notification);
      }, 10000);
    },
    removeNotification(notification) {
      const index = this.notifications.indexOf(notification);
      if (index > -1) {
        this.$delete(this.notifications, index);
      }
    },
    async postScan(data) {
      if (data.url && !data.name) {
        data.name = data.url;
      }
      this.addNotification("Scan " + data.name + " been started...");
      this.scansInProgress++;
      const user = await Auth.currentAuthenticatedUser({ bypassCache: true });
      const token = user.signInUserSession.idToken.jwtToken;

      API.post("scans", "/scans", {
        body: {
          ...data,
        },
        headers: {
          Authorization: token,
        },
      })
        .then((response) => {
          console.log(response);
          this.addNotification(
            `Scan ${data.name} has completed. <a href="/scan/${response.data}">Click to view.</a>`
          );
          this.scansInProgress--;
        })
        .catch((err) => {
          if (err.response.status == 402) {
            this.addNotification(
              "Monthly scan limit reached. Please upgrade to run more scans."
            );
          }
          this.addNotification("Scan " + data.name + " has failed");
          this.scansInProgress--;
        });
    },
  },
  computed: {
    initialScreen() {
      let state = "signup";
      if (this.$route.query && this.$route.query.screen === "signin") {
        state = "signin";
      }
      return state;
    },
  },
  created() {
    // authentication state managament
    onAuthUIStateChange((state, user) => {
      // set current user and load data after login
      if (state == "confirmSignUp") {
        window.lintrk("track", { conversion_id: 14411722 });
        window.fbq("track", "CompleteRegistration");
      }
      if (state === AuthState.SignedIn) {
        this.authState = state;
        this.user = user;
        console.log(user);
        Analytics.updateEndpoint({
          address: this.user.attributes.email,
          channelType: "EMAIL",
          optOut: "NONE",
          userId: this.user.attributes.sub,
          userAttributes: {
            username: [this.user.username],
            name: [this.user.attributes.name],
            email: [this.user.attributes.email],
            noOnboarding: [this.user.attributes["custom:noOnboarding"]],
          },
        });
        Analytics.record({ name: "signedIn" });
      }
    });
  },
};
</script>

<style>
.logo {
  width: 200px;
  margin: 0 auto;
  display: block;
  padding-top: 50px;
  margin-bottom: -50px;
  fill: #3047ec;
}

:root {
  --amplify-font-family: "Poppins";
  --amplify-primary-color: #3047ec;
  --amplify-primary-tint: #ff7359;
  --amplify-primary-shade: #e0573e;
}

amplify-button {
  @apply rounded !important;
}
</style>
